<template>
  <!-- Possible win and stake -->
  <div>
    <div class="single-ticket--row">
      <span class="total-stake">{{$t('vdog_stake_total')}}:</span>
      <span class="value-field">{{format(ticket.TotalPayIn)}} {{currency}}</span>
    </div>
    <div class="single-ticket--row" v-if="isPayloutBTVisible(ticket)">
      <span class="possible-win">{{$t(getWinBTText())}}:</span>
      <span class="value-field">{{getPossibleWinValue(ticket, false)}} {{currency}}</span>
    </div>
    <div class="single-ticket--row" v-if="isPayloutBTVisible(ticket)">
      <span class="possible-win">{{$t(getWinATText())}}:</span>
      <span class="value-field">{{getPossibleWinValue(ticket)}} {{currency}}</span>
    </div>
    <div class="single-ticket--row" v-if="!isPayloutBTVisible(ticket)">
      <span class="possible-win">{{$t(getWinText())}}:</span>
      <span class="value-field">{{getPossibleWinValue(ticket)}} {{currency}}</span>
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, VDogHelper, LanguageHelper],
  props: {
    ticket: {
      type: Object,
      required: true
    },
    currency: String,
    isHistory: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    getWinBTText () {
      return this.isHistory ? 'vdog_win_bt' : 'vdog_possibleWinBT'
    },
    getWinATText () {
      return this.isHistory ? 'vdog_win_at' : 'vdog_possibleWinAT'
    },
    getWinText () {
      return this.isHistory ? 'vdog_win' : 'vdog_possibleWin'
    },
    isPayloutBTVisible: function (ticket) {
      return ticket.TotalPayoutAT !== ticket.TotalPayoutBT
    },
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers(), 2)
    },
    getPossibleWinValue (ticket, isPossibleAT = true) {
      if (isPossibleAT) {
        return this.format(ticket.TotalPayoutAT)
      } else {
        return this.format(ticket.TotalPayoutBT)
      }
    }
  }
}
</script>
